import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  SHOW_AR_SIDE_SETTINGS: null,
  SHOW_AR_CREATE_WARNING_MODAL: null,
  SHOW_REIMBURSEMENT_APPROVER_REGISTRATION_MODAL: null,
  SHOW_REIMBURSEMENT_CREATE_LINK_MODAL: null,
  SHOW_REIMBURSEMENT_CONFIG: null,
  TOGGLE_ADD_VENDOR_MODAL: null,
  TOGGLE_ADD_PAYABLE_INVOICE_MODAL: null,
});
